import Router from "./router/Router";

const App = () => {
  return (
    <div className="App">
      <Router />
    </div>
  );
};

export default App;
